import Loading from "@src/components/loading";
import { useOrganizations } from "@src/modules/member/hooks/organizations";
import { DASHBOARD_PATH } from "@src/modules/member/modules/main/router/paths";
import { NEW_ORGANIZATION_PATH } from "@src/modules/member/modules/settings/router/paths";
import { buildMemberPath, memberPathPrefix } from "@src/modules/member/path";
import { Navigate } from "react-router-dom";

import { useAuthenticated } from "../../hooks/authorized";

const LAST_USED_ORG_KEY = "CURRENT_ORGANIZATION_CODE";

export default function DashboardRedirect() {
  useAuthenticated();
  const { data: orgsResponse, isLoading } = useOrganizations();

  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white">
        <Loading />
      </div>
    );
  }

  const orgs = orgsResponse?.data ?? [];

  if (orgs.length === 0) {
    return (
      <Navigate to={`${memberPathPrefix}/${NEW_ORGANIZATION_PATH()}`} replace />
    );
  }

  const storedOrg = localStorage.getItem(LAST_USED_ORG_KEY);
  const resolvedOrg =
    storedOrg && orgs.some((o) => o.code === storedOrg)
      ? storedOrg
      : orgs[0].code;

  return (
    <Navigate
      to={`${buildMemberPath(resolvedOrg)}/${DASHBOARD_PATH()}`}
      replace
    />
  );
}
